export const GET_RECIPES_BY_NAME = "GET_RECIPES_BY_NAME";

export const GET_ALL_RECIPES = "GET_ALL_RECIPES";

export const GET_DIETS = "GET_DIETS";

export const CLEAR_RECIPE_BY_NAME = "CLEAR_RECIPE_BY_NAME";

export const CLEAR_RECIPE_FILTERED = "CLEAR_RECIPE_FILTERED";

export const FILTER_BY_DIET = "FILTER_BY_DIET";

export const FILTER_BY_ORIGIN = "FILTER_BY_ORIGIN";

export const ORDER_BY_SCORE = "ORDER_BY_SCORE";

export const ORDER_BY_NAME = "ORDER_BY_NAME";

export const ADD_NEW_RECIPE = "ADD_NEW_RECIPE";

export const CURRENT_PAGE = "CURRENT_PAGE";

export const CURRENT_DIETS = "CURRENT_DIETS"